import React from 'react';
import Grid from '@material-ui/core/Grid';
import PrimeSwitch from '../../prime-switch';
import CustomSwitch from '../../custom-switch';
import { HomologatorConsumer } from '../../homologator-context';
import { queryCustom } from '../../../services/query';

class AppendableInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: props.loading || false,
      customTemplateData: [],
      hasDefaultOptions: false,
      selectedPrime: props.prime || null,
      selectedCustomTemplate: props.customTemplateId || null
    };

    this._abortController = new AbortController();

    this.handlePrime = this.handlePrime.bind(this);
    this.handleCustomSwitch = this.handleCustomSwitch.bind(this);
    this.getFormValue = this.getFormValue.bind(this);
    this.setFormValue = this.setFormValue.bind(this);
    this.isLoading = this.isLoading.bind(this);
  }

  componentDidMount() {
    queryCustom({ signal: this._abortController.signal })
      .then(({ data }) => {
        const listOptions = data.data || [];
        const defaultOptions = data.onlyCustomQuery;
        this.setState({ 
          customTemplateData: listOptions,
          hasDefaultOptions: !defaultOptions 
        });
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error(error);
          this.setState({ customTemplateData: [] });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.prime !== this.props.prime) {
      this.setState({ selectedPrime: this.props.prime });
    }
    if (prevProps.customTemplateId !== this.props.customTemplateId) {
      this.setState({ selectedCustomTemplate: this.props.customTemplateId });
    }
    if (prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading });
    }
  }

  componentWillUnmount() {
    this._abortController.abort();
  }

  getFormValue(key) {
    if (key === 'prime') {
      return this.state.selectedPrime !== null ? this.state.selectedPrime : this.props[key] || '';
    }
    if (key === 'customTemplateId') {
      return this.state.selectedCustomTemplate !== null ? 
        this.state.selectedCustomTemplate : this.props[key] || '';
    }
    return this.props[key] || '';
  }

  setFormValue(key, value) {
    // Atualizar o estado interno primeiro
    if (key === 'prime') {
      this.setState({ selectedPrime: value });
    } else if (key === 'customTemplateId') {
      this.setState({ selectedCustomTemplate: value });
    }

    if (this.props.onValueChange) {
      this.props.onValueChange(key, value);
    }
  }

  isLoading() {
    return this.state.loading || this.props.loading;
  }

  handlePrime(e) {
    // console.log('Prime switch clicked:', e.target.value); // DEBUG
    const value = parseInt(e.target.value, 10);
    
    if (!isNaN(value)) {
      // Limpar a seleção do customTemplate quando Prime for selecionado
      this.setState({
        selectedPrime: value,
        selectedCustomTemplate: null
      });
      
      // Propagar as mudanças para o componente pai
      this.setFormValue('customTemplateId', null);
      this.setFormValue('prime', value);
    }
  }

  handleCustomSwitch(e) {
    // console.log('Custom switch clicked:', e.target.value); // DEBUG
    const value = parseInt(e.target.value, 10);
    
    if (!isNaN(value)) {
      // Limpar a seleção do Prime quando customTemplate for selecionado
      this.setState({
        selectedPrime: null,
        selectedCustomTemplate: value
      });
      
      // Propagar as mudanças para o componente pai
      this.setFormValue('prime', null);
      this.setFormValue('customTemplateId', value);
    }
  }

  render() {
    const { className } = this.props;
    const { selectedPrime, selectedCustomTemplate, customTemplateData, hasDefaultOptions } = 
      this.state;
    
    return (
      <div className={`appendable-input ${className || ''}`}>
        <Grid item>
          <HomologatorConsumer>
            {({ requireImages, homologatorId }) => (
              <PrimeSwitch
                homologatorId={homologatorId}
                onChange={this.handlePrime}
                hasPrimePlus={requireImages}
                value={selectedPrime !== null ? `${selectedPrime}` : ''}
                loading={this.isLoading()}
                defaultOption={hasDefaultOptions}
                required
                customTemplateData={customTemplateData}
                selected={selectedPrime !== null}
              />
            )}
          </HomologatorConsumer>
          <CustomSwitch
            onChange={this.handleCustomSwitch}
            value={selectedCustomTemplate !== null ? `${selectedCustomTemplate}` : '0'}
            data={customTemplateData}
            loading={this.isLoading()}
            originPageContext={this.getFormValue('originPageContext') || 'HomeConsultingJoin'}
            optionPageContext={this.getFormValue('queryTypeId')}
            selected={selectedCustomTemplate !== null}
          />
        </Grid>
      </div>
    );
  }
}

export default AppendableInput;